import React, {useState, useEffect} from 'react';
import {ReactComponent as StarsIcon} from '../../../assets/icons/Stars.svg';
import {ReactComponent as StarsEmptyIcon} from '../../../assets/icons/StarsEmpty.svg';
import {ReactComponent as StarsHalfIcon} from '../../../assets/icons/StarsHalf.svg';
import './RatingEdit.scss';

const RatingEdit = ({mark = 0, onRatingChange}) => {
    const [selectedRating, setSelectedRating] = useState(mark);
    const [hoverRating, setHoverRating] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            const isTouchDevice =
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const isSmallScreen = window.innerWidth <= 768;
            setIsMobile(isTouchDevice || isSmallScreen);
        };

        checkMobile();

        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleStarClick = (rating) => {
        setSelectedRating(rating);
        if (onRatingChange) {
            onRatingChange(rating);
        }
    };

    const renderStars = () => {
        const stars = [];

        for (let i = 1; i <= 5; i++) {
            const isFull = i <= Math.floor(hoverRating || selectedRating);
            const isHalf =
                i === Math.ceil(hoverRating || selectedRating) &&
                (hoverRating || selectedRating) % 1 !== 0;

            const commonProps = {
                key: i,
                onClick: () => handleStarClick(i),
            };

            if (!isMobile) {
                commonProps.onMouseEnter = () => setHoverRating(i);
                commonProps.onMouseLeave = () => setHoverRating(0);
            }

            if (isFull) {
                stars.push(<StarsIcon {...commonProps} />);
            } else if (isHalf) {
                stars.push(<StarsHalfIcon {...commonProps} />);
            } else {
                stars.push(<StarsEmptyIcon {...commonProps} />);
            }
        }

        return stars
    };

    return <div className="rating-edit">{renderStars()}</div>;
};

export default RatingEdit;
